<script context="module">
    import Loki from "lokijs";
    import LokiIndexedAdapter from "lokijs/src/loki-indexed-adapter";
    var idbAdapter = new LokiIndexedAdapter("gscloud");

    var etags = {};
    var re = new RegExp('^([a-z:])*/', 'i');
    var re2 = /^\\/;
    var searchDb = null;
    var searchCollection = null;
    var historyCollection = null;
    var messageCollection = null;
    var syncCollection = null;
    var accountDb = null;
    var pendingReports = null;
    var pendingMedia = null;
    var savedProjects = null;
    var historyDb = null;
    var messageDb = null;
    var mediaDb = null;
    var cacheIndex = null;
    var cacheIndexDb = null;

    export 	function isTouchEnabled() {
        return ( 'ontouchstart' in window ) || 
           ( navigator.maxTouchPoints > 0 ) || 
           ( navigator.msMaxTouchPoints > 0 );
	}

    export function loadCacheIndex(id, callback) {
        if (cacheIndex) {
            callback();
            return;
        }
        cacheIndexDb = new Loki("cache_" + id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                cacheIndex = cacheIndexDb.getCollection("default");

                if (cacheIndex === null) {
                    cacheIndex = cacheIndexDb.addCollection("default", {
                        unique: ['id']
                    });
                }
                callback();
            },
            autosave: true,
            autosaveInterval: 4000
        });
    }

    export function loadAccount(id, callback) {
        accountDb = new Loki("account_" + id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                pendingReports = accountDb.getCollection("reports");
                if (pendingReports === null) {
                    pendingReports = accountDb.addCollection("reports", {
                        unique: ['id']
                    });
                }

                pendingMedia = accountDb.getCollection("media");
                if (pendingMedia === null) {
                    pendingMedia = accountDb.addCollection("media", {
                        unique: ['id']
                    });
                }

                savedProjects = accountDb.getCollection("projects");
                if (savedProjects === null) {
                    savedProjects = accountDb.addCollection("projects", {
                        unique: ['id']
                    });
                }

                var request = indexedDB.open("media_" + id, 1);
                request.onerror = function(event) {
                    callback();
                };
                request.onupgradeneeded = function (event) {
                    mediaDb = event.target.result;
                    mediaDb.createObjectStore("media");
                };
                request.onsuccess = function(event) {
                    mediaDb = event.target.result;
                    callback();
                };     
            },
            autosave: true,
            autosaveInterval: 4000
        });
    }
    
    export function loadHistory(id, callback) {
        var history = [];
        historyDb = new Loki("history_" + id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                historyCollection = historyDb.getCollection("default");

                if (historyCollection === null) {
                    historyCollection = historyDb.addCollection("default", {
                        unique: ["id"]
                    });
                }
                else {
                    history = historyCollection.chain().find().simplesort("timestamp").data({forceClones: true}).reverse();
                    history.forEach(function(item) {
                        item.properties.history_id = item.id
                    })  
                }
                callback(history);
            },
            autosave: true,
            autosaveInterval: 4000
        });
    }

     export function loadMessages(id, callback) {
        var messages = [];
        messageDb = new Loki("messages_" + id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                messageCollection = messageDb.getCollection("default");
                let syncCollection = messageDb.getCollection("sync");
                if (!syncCollection) {
                    syncCollection = messageDb.addCollection("sync", {
                        unique: ["id"]
                    });
                    syncCollection.insert({
                        id: "last",
                        time: 0
                    })
                }

                if (messageCollection === null) {
                    messageCollection = messageDb.addCollection("default", {
                        unique: ["id"]
                    });
                }
                else {
                    messages = messageCollection.chain().find().simplesort("timestamp").data({forceClones: true}).reverse();
                }
                callback(messages);
            },
            autosave: true,
            autosaveInterval: 4000
        });
    }

    export function getSavedProjects() {
       return savedProjects.chain().find().data();
    }

    export function setSavedProjects(projects) {
      savedProjects.clear({ removeIndices: true });
      savedProjects.insert(projects);
    }

    export function getHistory(id) {
        return historyCollection.by("id", id);
    }

    export function isUrl(value) {
        return re.test(value);
    }

    export function isLocalPath(value) {
        return re2.test(value);
    }

    export function getUnsentReport() {
        if (pendingReports)
            return pendingReports.findOne();
    }

    export function setSentReport(report) {
        pendingReports.remove(report);
    }

    export function getUnsentMedia() {
        if (pendingMedia)
            return pendingMedia.findOne();
    }

    export function setSentMedia(media) {
        pendingMedia.remove(media);
    }

    export function addPendingReport(report) {
        pendingReports.insert(report);
    }

    export function addPendingMedia(media, blob) {
        var transaction = mediaDb.transaction(["media"], "readwrite");
        transaction.objectStore("media").add(blob, media.id);
        pendingMedia.insert(media);
    }

    export function getMediaDb() {
        return mediaDb;
    }

    export function addHistory(report) {
        historyCollection.insert(report);
        var history = historyCollection.chain().find().simplesort("timestamp").data({forceClones: true}).reverse();
        history.forEach(function(item) {
            item.properties.history_id = item.id
        })

        return history;
    }

    export function getMessageSync() {
        let syncCollection = messageDb.getCollection("sync");
        let lastSync = syncCollection.by("id", "last");
        console.log(lastSync);
        return lastSync.time;
    }

    export function setMessageSync(time) {
        let syncCollection = messageDb.getCollection("sync");
        let lastSync = syncCollection.by("id", "last");
        lastSync.time = time;
        console.log(lastSync);
        syncCollection.update(lastSync);
        messageDb.saveDatabase();
    }

    export function addMessages(messages) {
        messageCollection.insert(messages);
        messageDb.saveDatabase();
    }

    export function getMessages() {
        return messageCollection.chain().find().simplesort("timestamp").data().reverse();
    }

    export function deleteMessage(message) {
        messageCollection.remove(message);
        messageDb.saveDatabase();
    }

    export function clearMessages() {
        messageCollection.remove(message);
        messageDb.saveDatabase();
    }

    export function editHistory(report) {
        var result = historyCollection.by("id", report.id);
        if (result) {
            result.timestamp = report.timestamp;
            result.uploaded = false;
            result.metadata = report.metadata;
            result.properties = report.properties;
            result.geometry = report.geometry;
            historyCollection.update(result);
        }
        else
            historyCollection.insert(report);

        var history = historyCollection.chain().find().simplesort("timestamp").data({forceClones: true}).reverse();
        history.forEach(function(item) {
            item.properties.history_id = item.id
        })

        return history;
    }

    export function clearHistory() {
        historyCollection.clear({ removeIndices: true });
    }

    export function closeSearchDb() {
        if (searchDb) {
            searchCollection = null;
            searchDb.close();
        }
    }

    export function getLinkedRows(table, id, field, callback) {
        var linkedDb = new Loki(table, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                var linkedCollection = linkedDb.getCollection("default");
                var obj = {};
                obj["properties." + field] = {
                    "$eq": id
                };
                var rows = linkedCollection.chain().find(obj).data();
                linkedCollection = null;
                linkedDb.close();
                callback(rows);
            },
            autosave: false,
            autosaveInterval: 4000
        });  
    }

    export function openSearchDb(id, callback) {
        if (searchDb) {
            searchCollection = null;
            searchDb.close();
        }
        searchDb = new Loki(id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                console.log(searchDb)
                searchCollection = searchDb.getCollection("default");
                if (callback)
                    callback()
            },
            autosave: false,
            autosaveInterval: 4000
        });
    }

    export function openIfExists(id, callback) {
        var retry = true;
        if (searchDb) {
            searchCollection = null;
            searchDb.close();
        }
        searchDb = new Loki(id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                //console.log(searchDb)
                if (searchDb.collections.length > 0) {
                    searchCollection = searchDb.getCollection("default");
                    if (callback) {
                        callback(true);
                    }
                }
                else if (retry) {
                    retry = false;
                    var ids = id.split("_");
                    openIfExists("source_" + ids[1], callback);
                }
                else if (callback) {
                    callback(false);
                }
            },
            autosave: false,
            autosaveInterval: 4000
        });
    }

    var operator_table = {
        '>': function(a, b) { return a > b; },
        '<': function(a, b) { return a < b; },
        '==': function(a, b) { return a == b; },
        '!=': function(a, b) { return a != b; },
        '<=': function(a, b) { return a <= b; },
        '>=': function(a, b) { return a >= b; }
    }

    export function getSearchCollection(filter) {
        if (!searchCollection)
            return;
        if (filter) {
            var filterFunc = function (obj) {
                return true;
            }
            var operator = filter.shift();
            if (operator == "all") {
                filterFunc = function (obj) {
                    var flag = true;
                    filter.map(function (condition) {
                        if (!(operator_table[condition[0]](obj.properties[condition[1]], condition[2]))) {
                            flag = false;
                        }
                    })
                    return flag;
                }
            }
            else if (operator == "any") {
                filterFunc = function (obj) {
                    var flag = false;
                    filter.map(function (condition) {
                        if (operator_table[condition[0]](obj.properties[condition[1]], condition[2])) {
                            flag = true;
                        }
                    })
                    return flag;
                }
            }
            else if (operator == "none") {
                filterFunc = function (obj) {
                    var flag = true;
                    filter.map(function (condition) {
                        if (operator_table[condition[0]](obj.properties[condition[1]], condition[2])) {
                            flag = false;
                        }
                    })
                    return flag;
                }
            }
            return {
                type: "FeatureCollection",
                features: searchCollection.chain().where(filterFunc).find().data()
            }
        }
        else {
            return {
                type: "FeatureCollection",
                features: searchCollection.chain().find().data()
            }
        }
    }

    export function getCenter(feature) {
        var latitude, longitude = 0
        if (feature.geometry.type == "Point") {
            longitude = feature.geometry.coordinates[0];
            latitude = feature.geometry.coordinates[1];
        }
        else if (feature.geometry.type == "GeometryCollection") {
            longitude = feature.geometry.geometries[0].coordinates[0];
            latitude = feature.geometry.geometries[0].coordinates[1];
        }
        else if (feature.geometry.type == "LineString") {
            var mid = Math.floor(feature.geometry.coordinates.length / 2);
            latitude = feature.geometry.coordinates[mid][1];
            longitude = feature.geometry.coordinates[mid][0];
        }
        else if (feature.geometry.type == "Polygon") {
            var centroid = getCentroid(feature.geometry.coordinates[0]);
            latitude = centroid[1];
            longitude = centroid[0];
        }
        return [longitude, latitude]
    }

    export function search(value, label, filter) {
        var obj = {};
        obj["properties." + label] = {
            "$regex": new RegExp(value, 'i')
        };
        if (filter) {
            var filterFunc = function (obj) {
                return true;
            }
            var operator = filter.shift();
            if (operator == "all") {
                filterFunc = function (obj) {
                    var flag = true;
                    filter.map(function (condition) {
                        if (!(operator_table[condition[0]](obj.properties[condition[1]], condition[2]))) {
                            flag = false;
                        }
                    })
                    return flag;
                }
            }
            else if (operator == "any") {
                filterFunc = function (obj) {
                    var flag = false;
                    filter.map(function (condition) {
                        if (operator_table[condition[0]](obj.properties[condition[1]], condition[2])) {
                            flag = true;
                        }
                    })
                    return flag;
                }
            }
            else if (operator == "none") {
                filterFunc = function (obj) {
                    var flag = true;
                    filter.map(function (condition) {
                        if (operator_table[condition[0]](obj.properties[condition[1]], condition[2])) {
                            flag = false;
                        }
                    })
                    return flag;
                }
            }
            return searchCollection.chain().where(filterFunc).find(obj).simplesort("properties." + label).data();
        }
        else {
            return searchCollection.chain().find(obj).simplesort("properties." + label).data();
        }
    }

    export function match(value, label) {
        console.log(value);
        console.log(label);
        return searchCollection.where(function(obj) {
            //console.log(obj);
            return obj.properties[label] === value;
        });
    }

    export function filter(filters, size, page, sort, reverse) {
        var obj = [];
        var collection = null;
        var limit = size
		var offset = (page - 1) * size
        if (filters) {
            Object.keys(filters).map(function (key) {
                var field = "properties." + key
                obj.push({
                    [field]: {
                        "$regex": new RegExp(filters[key], 'i')
                    }
                })
            })
            var total = searchCollection.chain().find({
               '$and': obj
            }).data().length
            return [searchCollection.chain().find({
               '$and': obj
            }).simplesort("properties." + sort, {
                desc: reverse
            }).offset(offset).limit(limit).data(), total]
        }
        else {
            var total = searchCollection.data.length
            return [searchCollection.chain().find().simplesort("properties." + sort, {
                desc: reverse
            }).offset(offset).limit(limit).data(), total]
        }
    }

    export function layerChanged(id, idField, old_val, new_val, callback) {
        var db = new Loki(id, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback: function () {
                var collection = db.getCollection("default");
                if (old_val && new_val) {
                    var obj = {};
                    obj["properties." + idField] = {
                        "$regex": new RegExp(old_val.properties[idField], 'i')
                    };
                    var record = collection.findOne(obj);
                    var properties = new_val.properties;
                    if (record) {
                        if (id.startsWith("layer"))
                            properties = {
                            ...record.properties,
                            ...properties
                            }
                        record.properties = properties;
                        if (new_val.geometry) {
                            record.geometry = new_val.geometry;
                        }
                        collection.update(record);
                    }
                    else {
                        collection.insert({
                            properties: properties,
                            geometry: new_val.geometry,
                            type: "Feature"
                        })
                    }
                    db.saveDatabase();
                    callback({
                        features: collection.data,
                        type: "FeatureCollection"
                    });
                }
                else if (new_val) {
                    var record = new_val;
                    record.type = "Feature";
                    collection.insert(record);
                    db.saveDatabase();
                    callback({
                        features: collection.data,
                        type: "FeatureCollection"
                    });
                }
                else if (old_val) {
                    var obj = {};
                    obj["properties." + idField] = {
                        "$regex": new RegExp(old_val.properties[idField], 'i')
                    };
                    var record = collection.findOne(obj);
                    collection.remove(record);
                    db.saveDatabase();
                    callback({
                        features: collection.data,
                        type: "FeatureCollection"
                    });
                }
            },
            autosave: false,
            autosaveInterval: 4000
        });
    }

    export function hasCache(type, path) {
        if (!cacheIndex)
            return false

        var record = cacheIndex.by("id", type + "_" + path);

        if (!record)
            return false

        return record;
    }

    export function getCache(type, id, callback) {
        var path = type + "_" + id;
        var db = new Loki(path, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback : function () {
                var collection = db.getCollection("default");
                if (collection === null) {
                    collection = db.addCollection("default", {
                        unique: ['id']
                    });
                }

                if (type === "map" || type === "project" || type === "form" || type === "template" || type === "schema") {
                    var result = collection.by("id", 1);
                    if (result) {
                        callback(result.data);
                    }
                }
                else if (type === "layer" || type === "source" || type === "annotation") {
                    var results = collection.data;
                    if (results) {
                        callback({
                            features: results,
                            type: "FeatureCollection"
                        });
                    }
                }
                else
                    callback();
            },
            autosave: false,
            autosaveInterval: 4000
        });
    }

    export function nthIndex(str, pat, n) {
        var L = str.length, i= -1;
        while(n-- && i++<L){
            i= str.indexOf(pat, i);
            if (i < 0) break;
        }
        return i;
    }

    export function setCache(type, id, etag, data) {
        if (!etag) {
        if (etags[id.substring(nthIndex(id, "_", 2) + 1)])
            etag = etags[id.substring(nthIndex(id, "_", 2) + 1)];
        }
        var path = type + "_" + id;
        var db = new Loki(path, {
            adapter: idbAdapter,
            autoload: true,
            autoloadCallback : function () {
                var collection = db.getCollection("default");
                if (collection === null) {
                    if (type === "project" || type === "map" || type === "form" || type === "template" || type === "schema") {
                        collection = db.addCollection("default", {
                            unique: ['id']
                        });
                    }
                    else {
                        collection = db.addCollection("default");
                    }
                }
                if (type === "map" || type === "project" || type === "form" || type === "template" || type === "schema") {
                    var result = collection.by("id", 1);
                    if (result) {
                        result.data = data;
                        collection.update(result);
                    }
                    else {
                        collection.insert({
                            id: 1,
                            data: data
                        });
                    }
                }
                else if (type === "layer" || type === "source" || type === "annotation") {
                    collection.clear({ removeIndices: true });
                    /*collection = null;
                    db.removeCollection("default");
                    collection = db.addCollection("default", {
                        unique: ['id']
                    });
                    console.log(collection);
                    console.log(data.features);*/
                    collection.insert(data.features);
                }

                db.saveDatabase(function(err) {
                    if (type == "annotation") {
                        searchCollection = collection;
                    }
                    else {
                        db.close();
                        if (!err) {
                            var result = cacheIndex.by("id", type + "_" + id);
                            if (result) {
                                result.etag = etag;
                                cacheIndex.update(result);
                            }
                            else {
                                cacheIndex.insert({
                                    id: type + "_" + id,
                                    etag: etag,
                                    _ts: new Date().getTime()
                                })
                            }
                        }
                    }
                });
            },
            autosave: false,
            autosaveInterval: 4000
        });
    }

    export function getServer() {
        if (window.origin == "http://localhost:5000" || window.origin == "http://192.168.86.3:5000")
            return "http://localhost:1323"
        else
		    return window.origin;
    }

    export function getLocalServer() {
		return "http://localhost:6278"
    }

    let server = getServer();
    let localServer = getLocalServer();

    export function asyncErrorHandler(promise) {
		return promise
            .then(data => ([data, undefined]))
            .catch(error => Promise.resolve([undefined, error]));
    }

    export async function fetchSnapshot(url, type, token, id, params, callback) {
        var bypass = true;
        var etag = "";
        var cacheEntry = hasCache(type, id);
        var cacheUrl = "/v1/cache/" + type + "/" + id;
        const [res, err] = await asyncErrorHandler(fetch(server + cacheUrl, {
            headers: {
                'Authorization': 'Bearer ' + token
			}
        }));
        
        if (res && !err) {
            const responseObj = await res.json();
            if (responseObj && responseObj.data) {
                etag = responseObj.data.etag;
                if (etag == cacheEntry.etag)
                    bypass = false;
            }
            else if (callback) {
                callback([undefined, "Not found"]);
                return;
            }
        }

        if (window.platform == "Windows") {
            if (cacheEntry._ts) {
                var now = new Date().getTime();
                if (now - cacheEntry._ts > 86400000) {
                    bypass = true;
                }
            }
            else {
                bypass = true;
            }
        }

        if (bypass) {
            const [res, err] = await asyncErrorHandler(fetch(localServer + url, params));
            if (!res || err) {
                if (callback)
                    callback([undefined, "Connection error"]);
                return;
            }

            const responseObj = await res.json();
            if (responseObj.status == "error" && callback) {
                callback([undefined, responseObj.message]);
                return;
            }
            else if (responseObj.status == "success") {
                var result = cacheIndex.by("id", type + "_" + id);
                if (result) {
                    result.etag = etag;
                    cacheIndex.update(result);
                }
                else {
                    cacheIndex.insert({
                        id: type + "_" + id,
                        etag: etag,
                        _ts: new Date().getTime()
                    })
                }
                if (callback) {
                    callback([responseObj, undefined]);
                    return;
                }
            }
            else if (!res.ok && callback) {
                callback([undefined, responseObj.message]);
                return;
            }
            else {
                var result = cacheIndex.by("id", type + "_" + id);
                if (result) {
                    result.etag = etag;
                    cacheIndex.update(result);
                }
                else {
                    cacheIndex.insert({
                        id: type + "_" + id,
                        etag: etag,
                        _ts: new Date().getTime()
                    })
                }
                if (callback) {
                    callback([responseObj, undefined]);
                    return;
                }
            }
        }

        if (callback) {
            callback([true, undefined]);
            return;
        }
    }

    export async function cachedFetch(url, type, user, id, params, callback) {
        var bypass = true;
        var etag = "";
        var path = id;
        if (type == "project" || type == "map")
            path = user + "_" + id;
        var cacheEntry = hasCache(type, path);
        var cacheUrl = "/v1/cache/" + type + "/" + id;
        const [res, err] = await asyncErrorHandler(fetch(server + cacheUrl, params));
        var endpoint = server + url;
        if (res && !err) {
            const responseObj = await res.json();
            if (responseObj && responseObj.data) {
                etag = responseObj.data.etag;
                if (etag == cacheEntry.etag) {
                    bypass = false;
                }
                if (responseObj.data.url) {
                    endpoint = responseObj.data.url;
                    params = null;
                }
            }
        }

         if (window.platform == "Windows") {
            if (cacheEntry._ts) {
                var now = new Date().getTime();
                if (now - cacheEntry._ts > 86400000) {
                    bypass = true;
                }
            }
            else {
                bypass = true;
            }
        }

        if (bypass) {
            const [res, err] = await asyncErrorHandler(fetch(endpoint, params));
            if (!res || err) {
                if (callback)
                    callback([undefined, "Connection error"]);
                return;
            }

            const responseObj = await res.json();
            if (responseObj.status == "error" && callback) {
                callback([undefined, responseObj.message]);
                return;
            }
            else if (responseObj.status == "success") {
                setCache(type, path, etag, responseObj);
                if (callback) {
                    callback([responseObj, undefined]);
                    return;
                }
            }
            else if (!res.ok && callback) {
                callback([undefined, responseObj.message]);
                return;
            }
            else {
                setCache(type, path, etag, responseObj);
                if (callback) {
                    callback([responseObj, undefined]);
                    return;
                }
            }
        }
        else if (cacheEntry && (type == "map" || type == "scene")) {
            getCache(type, path, async function(data) {
                const [res, err] = await asyncErrorHandler(fetch(server + "/v1/media/project/" + data.data.project + "/" + data.data.media_id, params));
                if (!res || err) {
                    if (callback)
                        callback([undefined, "Connection error"]);
                    return;
                }
                const responseObj = await res.json();
                if (responseObj.status == "error" && callback) {
                    callback([undefined, responseObj.message]);
                    return;
                }
                else if (responseObj.status == "success") {
                    if (shallowEqual(data.data.media, responseObj.data.media)) {
                        data.data.media = responseObj.data.media;
                        setCache(type, path, cacheEntry.etag, data);
                    }
                    if (callback) {
                        callback([responseObj, undefined]);
                        return;
                    }
                }
            })
        }
        else if (cacheEntry && (type == "project")) {
            getCache(type, path, async function(data) {
                const [res, err] = await asyncErrorHandler(fetch(server + "/v1/media/project/" + id + "/0", params));
                if (!res || err) {
                    if (callback)
                        callback([undefined, "Connection error"]);
                    return;
                }
                const responseObj = await res.json();
                if (responseObj.status == "error" && callback) {
                    callback([undefined, responseObj.message]);
                    return;
                }
                else if (responseObj.status == "success") {
                    data.data.media = responseObj.data.media.project;
                    if (shallowEqual(data.data.media, responseObj.data.media.project)) {
                        data.data.media = responseObj.data.media.project;
                        setCache(type, path, cacheEntry.etag, data);
                    }
                    if (callback) {
                        callback([responseObj, undefined]);
                        return;
                    }
                }
            })
        }
        else if (callback) {
            getCache(type, path, function(data) {
                callback([data, undefined]);
            })
        }
    }

    function shallowEqual(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (object1[key] !== object2[key]) {
            return false;
            }
        }

        return true;
    }

    export function getCentroid(arr) {
    var twoTimesSignedArea = 0;
    var cxTimes6SignedArea = 0;
    var cyTimes6SignedArea = 0;

    var length = arr.length;

    var x = function (i) { return arr[i % length][0]; };
    var y = function (i) { return arr[i % length][1]; };

    for ( var i = 0; i < arr.length; i++) {
        var twoSA = x(i)*y(i+1) - x(i+1)*y(i);
        twoTimesSignedArea += twoSA;
        cxTimes6SignedArea += (x(i) + x(i+1)) * twoSA;
        cyTimes6SignedArea += (y(i) + y(i+1)) * twoSA;
    }
    var sixSignedArea = 3 * twoTimesSignedArea;
    return [ cxTimes6SignedArea / sixSignedArea, cyTimes6SignedArea / sixSignedArea];
  }

    export function generateID() {
      var lut = []; for (var i = 0; i < 256; i++) { lut[i] = (i < 16 ? "0" : "") + (i).toString(16); }
      var d0 = Math.random() * 0xffffffff | 0;
      var d1 = Math.random() * 0xffffffff | 0;
      var d2 = Math.random() * 0xffffffff | 0;
      var d3 = Math.random() * 0xffffffff | 0;
      return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + "-" +
      lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + "-" + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + "-" +
      lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + "-" + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
      lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
    }

    export async function fetchData(url, params) {
        const [res, err] = await asyncErrorHandler(fetch(url, params));
        console.log(err);
        if (!res || err) {
            return [undefined, "Connection error"]
        }

        const responseObj = await res.json();
        if (responseObj.status == "error")
            return [undefined, responseObj.message];
        else if (!res.ok)
            return [undefined, responseObj.message];

        return [responseObj, undefined]
    }

    export function flatten(ob) {
        var toReturn = {};
        
        for (var i in ob) {
          if (!ob.hasOwnProperty(i)) continue;
          
          if ((typeof ob[i]) == 'object') {
            if (Array.isArray(ob[i])) {
              if (ob[i].length > 0)
                toReturn[i] = ob[i].join(",");
            }
            else {
              var flatObject = flatten(ob[i]);
              for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;
                
                toReturn[x] = flatObject[x];
              }
            }
          }
          else {
            toReturn[i] = ob[i];
          }
        }
        return toReturn;
    }
</script>